export * from './keep-html.pipe';
export * from './safe-html.pipe';


// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts